import { useScrollToTop } from './scroll-to-top.hook';

const ScrollToTop = () => {
	useScrollToTop();
	return null;
};

ScrollToTop.displayName = 'ScrollToTop';

export { ScrollToTop };
